
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-demo-think","docs-x-markdown-components-demo-thoughtchain"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components.zh-CN.md?type=demo')
};